// ── Feedback contract (REQ-23) ──────────────────────────────────────────────
// Citizens send a complaint/suggestion/issue either under their name or anonymously.
// Go-live: add `import { apiClient } from 'src/api/client';` and uncomment the
// `// Real:` lines — SIGNATURES UNCHANGED. Reuses CommsError from ./types.
import { sleep } from 'src/api/_mock/util';
import { CommsError } from './types';

export type FeedbackCategory = 'complaint' | 'suggestion' | 'issue' | 'other';

export type FeedbackInput = {
  anonymous: boolean;
  category: FeedbackCategory;
  subject: string;
  message: string;
  /** Present only for NAMED submissions; omitted entirely when anonymous. */
  name?: string;
  email?: string;
};

export type FeedbackResult = { id: string; acknowledged: boolean };

export type FeedbackItem = {
  id: string;
  category: FeedbackCategory;
  subject: string;
  createdAt: string;
  status: 'received' | 'in_review' | 'resolved';
};

export async function submitFeedback(
  input: FeedbackInput
): Promise<FeedbackResult> {
  // Real: return (await apiClient.post('comms/feedback', input)).data;
  //   BACKEND CONTRACT: when input.anonymous===true the server MUST NOT persist or
  //   forward name/email/user linkage, and MUST exclude it from the sender's own
  //   portal feedback list. This FE already sends no name/email when anonymous.
  await sleep(300);
  if (!input.message.trim()) throw new CommsError('EMPTY_MESSAGE');
  return {
    id: `fb_${Math.random().toString(36).slice(2, 8)}`,
    acknowledged: true,
  };
}

export async function getMyFeedback(input: {
  userId: string;
}): Promise<FeedbackItem[]> {
  // Real: return (await apiClient.get('comms/feedback/mine', { params: { user_id: input.userId } })).data;
  await sleep(200);
  void input;
  return [
    {
      id: 'fb_seed01',
      category: 'issue',
      subject: 'Tyhjennys jäi tekemättä',
      createdAt: '2026-06-20T09:00:00Z',
      status: 'in_review',
    },
  ];
}
